<template>
  <qc-dialog class="tc-15-rich-dialog cos" :show="innerShow" type="custom" :title="$t('cos.upload_files')" :default-cancel="false"
    :width="700" @close="closeDialog" :closeTriggers="['esc']">
    <div>

      <qc-step :active="stepIndex">
        <qc-step-item>{{$t('cos.select_upload_object')}}</qc-step-item>
        <qc-step-item>{{$t('cos.set_object_properties')}}</qc-step-item>
      </qc-step>

      <div class="advance-upload-content" ref="dragArea"
        @dragover.prevent="$refs.fileTable.$el.classList.add('cos-drag-area')"
        @dragenter.prevent="$refs.fileTable.$el.classList.add('cos-drag-area')"
        @dragleave.prevent="$refs.fileTable.$el.classList.remove('cos-drag-area')" @drop.prevent="handleDrop">
        <div class="step1" v-if="stepIndex === 0">
          <div class="mb-20">
            <qc-button size="small" :title="$t('cos.select_files')" @click="$refs.fileInput.click()">{{$t('cos.select_files')}}</qc-button>
            <input ref="fileInput" type="file" multiple="multiple" style="display: none;" @change="handleFileInput">
            <qc-button size="small" type="weak" :title="$t('cos.select_folder')" @click="$refs.directoryInput.click()" class="ml-10">
              {{$t('cos.select_folder')}}
            </qc-button>
            <input ref="directoryInput" type="file" multiple="multiple" webkitdirectory="webkitdirectory"
              style="display: none;" @change="handleDirectoryInput">
          </div>

          <qc-table min-height="200px" max-height="275px" :list="form.files" ref="fileTable">
            <qc-table-column :label="$t('cos.file_folder')">
              <template slot-scope="{ item }">
                <div :title="item[0].folder || item[0].name">
                  <div class="cos-icon--32" :class="item[0].folder || item[0].name | FileIcon(!!item[0].folder)"></div>
                  <a href="javascript:void(0)" class="table-file__name text-overflow">
                    {{item[0].folder || item[0].name}}
                  </a>
                  <div v-if="item[0].alertText" class="text-alert text-overflow"
                    style="font-size:5px;color:red;margin-left:40px;">
                    {{item[0].alertText}}</div>
                </div>
              </template>
            </qc-table-column>
            <qc-table-column :label="$t('cos.size')" field="size" :width="isMobile ? '25%' : 150">
              <template slot-scope="{ item }">
                <div>
                  {{item[0].folderSize || item[0].size | formatSize}}
                </div>
              </template>
            </qc-table-column>
            <qc-table-column :label="$t('cos.operation')" :width="isMobile ? '20%' : 80">
              <template slot-scope="{ item, rowIndex}">
                <a href="javascript:void(0)" :title="$t('cos.delete')" @click="onDeleteFilesOrFolders(item,rowIndex)">
                  <i class="remove-icon"></i>
                </a>
              </template>
            </qc-table-column>
            <template slot="empty-tips">
              <div class="table-body blank" style="height: 200px;">
                <template>
                  <!-- <div class="blank-img lost"></div> -->
                  <div class="blank-title">{{$t('cos.no_files_selected')}}</div>
                  <div class="blank-help">{{$t('cos.drag_upload_tip')}}</div>
                </template>
              </div>
            </template>
          </qc-table>
        </div>
        <div class="step2" v-else>
          <qc-alert>{{$t('cos.object_properties_tip')}}</qc-alert>
          <ul class="form-list">
            <li class="pure-text-row">
              <div class="form-label"><label>{{$t('cos.storage_type')}}</label></div>
              <div class="form-input">
                <p v-if="openMaz">
                  <qc-radio-group v-model="form.storageClass">
                    <qc-radio value="MAZ_STANDARD" :title="$t('cos.standard_storage_maz')">{{$t('cos.standard_storage_maz')}}</qc-radio>
                    <qc-radio value="MAZ_STANDARD_IA" :title="$t('cos.low_frequency_storage_maz')">{{$t('cos.low_frequency_storage_maz')}}</qc-radio>
                  </qc-radio-group>
                </p>
                <p v-else>
                  <qc-radio-group v-model="form.storageClass">
                    <qc-radio value="STANDARD" :title="$t('cos.standard_storage')">{{$t('cos.standard_storage')}}</qc-radio>
                    <qc-radio value="STANDARD_IA" :title="$t('cos.low_frequency_storage')">{{$t('cos.low_frequency_storage')}}</qc-radio>
                    <qc-radio value="ARCHIVE" :title="$t('cos.archive_storage')" v-if="allowCAS">
                      {{$t('cos.archive_storage')}}
                    </qc-radio>
                  </qc-radio-group>
                </p>
              </div>
            </li>
            <li class="pure-text-row">
              <div class="form-label"><label>{{$t('cos.access_permission')}}</label></div>
              <div class="form-input">
                <p>
                  <qc-radio-group v-model="form.aclType">
                    <qc-radio value="default" :title="$t('cos.inherit_permission')">{{$t('cos.inherit_permission')}}</qc-radio>
                    <qc-radio value="private" :title="$t('cos.private_read_write')">{{$t('cos.private_read_write')}}</qc-radio>
                    <qc-radio value="public-read" :title="$t('cos.public_read_private_write')">{{$t('cos.public_read_private_write')}}</qc-radio>
                  </qc-radio-group>
                </p>
              </div>
            </li>
            <li class="pure-text-row">
              <div class="form-label"><label>{{$t('cos.storage_method')}}</label></div>
              <div class="form-input">
                <p>{{$t('cos.if_same_name_file_exists')}}</p>
                <p>
                  <qc-radio-group v-model="form.uploadType">
                    <qc-radio value="replace">{{$t('cos.overwrite')}}&emsp;&emsp;&nbsp;
                    </qc-radio>
                    <qc-radio value="rename">{{$t('cos.rename')}}&emsp;&nbsp;</qc-radio>
                    <qc-radio value="skip">{{$t('cos.skip')}}</qc-radio>
                  </qc-radio-group>
                </p>
              </div>
            </li>

            <!-- 对象标签管理 -->
            <li class="pure-text-row">
              <div class="form-label"><label>{{$t('cos.object_tags')}}</label></div>
              <div class="form-input">
                <add-tag-util v-model='tagList'></add-tag-util>
              </div>
            </li>
            <!-- 新增 元数据 添加栏 -->
            <li class="pure-text-row">
              <div class="form-label"><label>{{$t('cos.metadata')}}</label></div>
              <div class="form-input">
                <div class="form-unit">
                  <qc-table min-height="30px" max-height="170px" :overflowHidden="true" :list="metaDataList">
                    <qc-table-column :label="$t('cos.parameter')" field="params" :width="isMobile ? '110px' : 'auto'">
                      <template slot-scope="{ item }">
                        <select class="tc-15-select s" v-model="item.header" :style="computedParamsStyle(item)">
                          <option value="" selected="selected">{{$t('cos.select_project')}}</option>
                          <option value="Content-Type">Content-Type</option>
                          <option value="Cache-Control">Cache-Control</option>
                          <option value="Content-Disposition">Content-Disposition</option>
                          <option value="Expires">Expires</option>
                          <option value="x-cos-meta-">x-cos-meta-</option>
                        </select>
                        <input type="text" class="tc-15-input-text "
                          style="width: 100px; display: inline-block;vertical-align: middle;"
                          v-show="item.header === 'x-cos-meta-'" v-model.trim="item.headerSuffix">
                      </template>
                    </qc-table-column>
                    <qc-table-column :label="$t('cos.value')" field="value" :width="isMobile ? '85px' : '200px'">
                      <template slot-scope="{ item }">
                        <input type="text" class="tc-15-input-text " :placeholder="$t('cos.value')" v-model.trim="item.val">
                      </template>
                    </qc-table-column>
                    <qc-table-column :label="$t('cos.operation')" field="option" :width="isMobile ? '50px' : '80px'">
                      <template slot-scope="{ rowIndex }">
                        <qc-button type="link" @click="deleteMetaData(rowIndex)">{{$t('cos.delete')}}</qc-button>
                      </template>
                    </qc-table-column>
                    <span style="display: none" slot="empty-tips"></span>
                    <a href="javascript:;" slot="footer" @click="addMetaData">{{$t('cos.add_parameter')}}</a>
                  </qc-table>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div slot="button">
      <div class="justify-grid">
        <div class="col"></div>
        <div class="col">
          <qc-button type="weak" :disabled="disableBtnProxy" @click="onChangeStep" :title="!stepIndex?$t('cos.next_step'):$t('cos.previous_step')">
            {{!stepIndex?$t('cos.next_step'):$t('cos.previous_step')}}</qc-button>
          <qc-button type="default" :disabled="disableBtnProxy" @click="onSubmit" :title="$t('cos.upload')">{{$t('cos.upload')}}</qc-button>
        </div>
      </div>
    </div>

  </qc-dialog>
</template>

<script>
import addTagUtil from 'components/common/addTagUtil';

import eventProxy from 'tools/eventProxy';
import { cos } from 'helper/cos/index';
import device from 'current-device';

import {
  tips,
  getInnerProps,
  getSizeStr,
  readDirectory,
  dateToUnix,
  path,
} from 'tools/utils';
import { config } from 'tools/config';
import validate from 'helper/validate';

export default {
  components: {
    addTagUtil,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    bucketInfo: Object,
    openMaz: {
      type: Boolean,
      default: false,
    },
    allowCAS: {
      type: Boolean,
      // required: true,
      default: true,
    },
  },
  data() {
    return {
      stepIndex: 0,
      form: {
        files: [],
        storageClass: 'STANDARD',
        aclType: 'default',
        uploadType: 'replace',
      },
      tagList: [{ key: '', Value: '' }],
      metaDataList: [],
      disableBtn: false,
    };
  },
  computed: {
    innerShow: getInnerProps('show'),
    disableBtnProxy() {
      const disabled = this.form.files.length === 0 || this.disableBtn;
      return disabled;
    },
    isMobile() {
      return device.mobile();
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.initData();
      }
    },
  },
  methods: {
    // 计算元数据的样式
    computedParamsStyle(item) {
      return {
        minWidth: (item.header === 'x-cos-meta-' || device.mobile()) ? '120px' : '220px',
        width: (item.header === 'x-cos-meta-' || device.mobile()) ? '120px' : '220px',
      };
    },
    // 初始化
    initData() {
      const defaultStorageClass = this.openMaz ? 'MAZ_STANDARD' : 'STANDARD';
      const form = {
        files: [],
        storageClass: defaultStorageClass,
        aclType: 'default',
        uploadType: 'replace',
      };
      this.form = form;
      this.stepIndex = 0;
      this.tagList = [{ key: '', Value: '' }];
      this.metaDataList = [];
    },
    // 选择文件上传
    handleFileInput(event) {
      const { files } = event.target;
      this.filesDeal(files);
      this.$refs.fileInput.value = '';
    },
    // 选择文件夹
    handleDirectoryInput(event) {
      const { files } = event.target;
      this.filesDeal(files);
      this.$refs.directoryInput.value = '';
    },
    //  处理拖放的文件/文件夹
    async handleDrop(event) {
      const { dataTransfer } = event;
      const items = dataTransfer.items || [];

      if (items[0] && items[0].webkitGetAsEntry) {
        const firstEntry = items[0].webkitGetAsEntry();
        try {
          const allfiles = await readDirectory(firstEntry.filesystem.root);
          this.filesDeal(allfiles);
        } catch (error) {
          const { files } = dataTransfer;
          this.filesDeal(files);
        }
      } else {
        const { files } = dataTransfer;
        this.filesDeal(files);
      }
      this.$refs.fileTable.$el.classList.remove('cos-drag-area');
    },
    // 检测文件或者文件夹是否违规
    checkFilesForbidden(files, type) {
      let Files = [];
      const errorFile = [];
      const { fileMaxSize } = config;

      const result = {};
      if (!(files instanceof Array)) {
        Files = [files];
      } else {
        for (let i = 0, len = files.length; i < len; i++) {
          Files.push(files[i]);
        }
      }

      switch (type) {
        case 'file':
          for (let i = 0, len = Files.length; i < len; i++) {
            const file = Files[i];
            if (file.size > fileMaxSize) {
              errorFile.push(file);
            }
          }
          break;
        case 'folder':
        default:
          for (let i = 0, len = Files.length; i < len; i++) {
            const file = Files[i];
            if (file.folderSize > fileMaxSize) {
              errorFile.push(file);
            }
          }
          break;
      }

      result.errorFile = errorFile;

      return result;
    },
    renderDialogFiles() {
      const { fileMaxSize } = config;
      let disableBtn = false;
      this.form.files.forEach(fileList => {
        const result = this.checkFilesForbidden(fileList, 'file');

        if (result.errorFile && result.errorFile.length) {
          disableBtn = true;
          fileList[0].alertText = this.$t('cos.file_size_exceeds_limit', { maxSize: getSizeStr(fileMaxSize) });
          // fileList[0].alertText = '文件大小超过限制';
        }
      });
      this.disableBtn = disableBtn;
    },
    filesDeal(files) {
      // 将文件分类，用于文件夹处理
      const fileObjList = this.filesClassify(files);

      Object.values(fileObjList).forEach(fileList => {
        this.form.files.push(fileList); // 所有要上传的文件
      });

      this.renderDialogFiles();
    },
    filesClassify(files) {
      const fileObj = {};

      for (let i = 0, len = files.length; i < len; i++) {
        const file = files[i];
        const fullPath = file.fullPath || file.webkitRelativePath || file.name;
        const folder = fullPath.split('/')[0];

        if (folder !== fullPath) {
          file.folder = folder;
        }

        fileObj[folder] = fileObj[folder] || [];
        /**
         * 文件夹下的文件：有folder属性
         * 文件夹下的文件夹：有isFolder属性、有folder属性
         * 文件夹：有isFolder属性
         * 文件：无folder属性
         */
        fileObj[folder].push(file);
      }

      Object.values(fileObj).forEach(folder => {
        let folderSize = 0;

        Object.values(folder).forEach(file => {
          folderSize += file.size;
        });

        Object.values(folder).forEach(file => {
          file.folderSize = folderSize;
        });
      });

      return fileObj;
    },
    onDeleteFilesOrFolders(item, index) {
      this.form.files.splice(index, 1);
      this.renderDialogFiles();
    },
    onChangeStep() {
      const check = val => (val === 1 ? 0 : 1);
      this.stepIndex = check(this.stepIndex);
    },
    // 获取对象标签中的数据
    // 用于加到x-cos-tagging头部，需要encode
    getInputTags() {
      const tagList = [];
      const tags = [];
      let errMsg = '';
      this.tagList.forEach(item => {
        if (item.Key || item.Value) {
          tagList.push({
            Key: item.Key,
            Value: item.Value,
          });
        }
      });
      if (tagList.length) {
        errMsg = validate.getTagsErrorMsg(tagList);
        if (!errMsg) {
          tagList.forEach(item => {
            if (item.Key || item.Value) {
              tags.push(
                `${encodeURIComponent(item.Key)}=${encodeURIComponent(
                  item.Value,
                )}`,
              );
            }
          });
        }
      }
      return {
        errMsg,
        tags,
      };
    },
    getUploadHeaders() {
      const headerObj = {};
      let tmpHeader;
      let tmpVal;
      let customHeaderSuffix;

      this.metaDataList.forEach(item => {
        tmpHeader = item.header;
        tmpVal = item.val;

        if (!tmpHeader || !tmpVal) {
          return;
        }

        if (tmpHeader === 'x-cos-meta-') {
          customHeaderSuffix = item.headerSuffix;

          if (!customHeaderSuffix) return;
          tmpHeader += customHeaderSuffix;
        }
        headerObj[tmpHeader] = tmpVal;
      });
      return headerObj;
    },
    // 新增【元数据】
    addMetaData() {
      const headerObj = {};
      headerObj.header = '';
      headerObj.val = '';
      this.metaDataList.push(headerObj);
    },
    // 删除【元数据】
    deleteMetaData(rowIndex) {
      this.metaDataList.splice(rowIndex, 1);
    },
    onSubmit() {
      if (!this.form.files.length) {
        return;
      }

      this.closeDialog();

      // 处理标签
      const tagInput = this.getInputTags();
      if (tagInput.errMsg) {
        tips.error(tagInput.errMsg);
        return;
      }

      // 处理元数据
      const Headers = this.getUploadHeaders();
      if (tagInput.tags.length) {
        Headers['x-cos-tagging'] = tagInput.tags.join('&');
      }

      // 处理要上传文件
      const files = [];
      const { Bucket, Region, Prefix } = this.bucketInfo;
      const { storageClass: StorageClass, aclType: ACL } = this.form;
      this.form.files.forEach(fileArr => {
        fileArr.forEach(file => {
          const Key = Prefix + (file.fullPath || file.webkitRelativePath || file.name);
          const param = {
            Bucket,
            Region,
            Key,
            name: file.fullPath || file.webkitRelativePath || file.name,
            StorageClass,
          };

          if (ACL !== 'default') {
            param.ACL = ACL;
          }

          if (Key.endsWith('/')) param.ContentType = 'application/x-directory';

          if (Object.keys(Headers).length > 0) {
            param.Headers = Headers;
          }

          if (file.isFolder) {
            param.Body = '';
          } else {
            param.Body = file;
          }
          files.push(param);
        });
      });

      const { uploadType } = this.form;
      // 覆盖则直接上传
      if (uploadType === 'replace') {
        this.uploadFiles({ files });
        return;
      }

      // 重命名，跳过进行额外的处理
      tips.loading(this.$t('cos.checking_files'));
      this.onFilterFiles({ files, uploadType })
        .then(data => {
          tips.closeTips();
          this.uploadFiles(data);
        })
        .catch(err => {
          tips.closeTips();
          tips.error(err || err.error);
        });
    },
    /**
     * 过滤存储桶中已存在的文件/文件夹内容
     * @param {Object} data
     *      @param {ArrayObject} files 要过滤的文件
     *      @param {String} folderName 要过滤的存储桶中文件夹前缀
     *      @param {String} uploadType 存储类型：replace(覆盖)、重命名、skip(跳过)
     */
    onFilterFiles(data) {
      const localMap = {};
      const remoteMap = {};
      const localList = data.files;
      const { folderName, uploadType } = data;
      const { Bucket, Region, Prefix } = this.bucketInfo;

      localList.forEach(file => {
        localMap[file.name] = file;
      });

      const skipMap = {};
      const localCount = localList.length;
      let compareCount = 0;

      const getRenameKey = key => {
        const dir = path.dirname(key);
        const ext = path.extname(key);
        const name = decodeURIComponent(path.basename(key, ext));
        let realKey = key;

        // 检测存储桶是否存在该对象名
        for (let i = 1; i < 10000 && remoteMap[Prefix + realKey]; i++) {
          realKey = `${dir ? `${dir}/` : ''}${name} (${i})${ext}`;
        }
        return realKey;
      };

      return new Promise((resolve, reject) => {
        const prefix = folderName ? `${Prefix + folderName}/` : Prefix; // 如果有给出特定文件夹名，则只获取存储桶对应文件夹下的文件
        let listMarker = '';
        const next = async () => {
          try {
            const res = await cos.getBucket(
              {
                Bucket,
                Region,
                Prefix: prefix,
                Marker: listMarker,
              },
            );
            if (res && res.Contents && res.Contents.length) {
              res.Contents.forEach(file => {
                remoteMap[file.Key] = file;
              });

              res.Contents.forEach(remoteItem => {
                const remoteName = remoteItem.Key.substr(Prefix.length);
                if (localMap[remoteName]) {
                  const localItem = localMap[remoteName];
                  const localName = localItem.name;
                  if (uploadType === 'skip') {
                    // 简单跳过
                    skipMap[remoteName] = true;
                    compareCount++;
                  } else if (
                    uploadType === 'rename'
                    && localName[localName.length - 1] !== '/'
                  ) {
                    localItem.name = getRenameKey(localName);
                    const filePath = Prefix + localItem.name;
                    localItem.Key = filePath;
                  } else if (uploadType === 'replaceDiff') {
                    if (
                      dateToUnix(localItem.mtime)
                        === dateToUnix(remoteItem.LastModified)
                      && localItem.size === parseInt(remoteItem.Size, 10)
                    ) {
                      skipMap[remoteName] = true;
                    }
                  }
                }
              });
            }
            if (compareCount < localCount && res.IsTruncated === 'true') {
              listMarker = res.NextMarker;
              next();
            } else {
              const readyFiles = localList.filter(
                item => !skipMap[item.name],
              );
              if (readyFiles.length) {
                resolve({ files: readyFiles });
              } else {
                const errMsg = this.$t('cos.no_files_to_upload');
                reject(errMsg);
              }
            }
          } catch (error) {
            console.log('next -> error', error);
            reject(error);
          }
        };

        next();
      });
    },
    uploadFiles(data) {
      const { files } = data;
      const { Bucket, Region } = this.bucketInfo;
      files.forEach(file => {
        // 处理文件上传完成时间
        file.onFileFinish = (err, result) => {
          eventProxy.emit('upload-completed', {
            err,
            data: {
              Bucket,
              Region,
              Key: file.Key,
              ETag: result && result.ETag,
              size: (file.Body && file.Body.size) || 0,
              LastModified: file.Body && file.Body.lastModifiedDate,
              Headers,
              StorageClass: file.StorageClass,
            },
          });
        };
      });
      cos.uploadFiles({ files: data.files });
      eventProxy.emit('upload-add');
    },
    closeDialog() {
      this.innerShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
$xs: 360px;
$sm: 600px;
.tc-15-rich-dialog {
  ::v-deep .dialog__container {
    @media screen and (max-width: $sm) {
      width: 100%;
      .tc-15-rich-dialog {
        width: 100% !important;
        .tc-15-rich-dialog-hd {
          margin: 0 10px 10px;
        }
        .tc-15-rich-dialog-bd{
          padding: 0 10px;
          .form-label > label {
            padding-right: 15px;
          }
          .form-input {
            .form-ctrl-label {
              margin-right: 12px;
            }
            .tc-link-btn{
              margin-left: 0;
            }
          }
          .ml-5 > input {
            width: 125px;
          }
          table td .tc-15-input-text  {
            width: 80px;
          }
        }
      }
    }
    @media screen and (max-width: $xs) {
      .tc-15-step-arrow {
        margin: 0 5px;
      }
    }
    .tc-15-rich-dialog {
      .advance-upload-content {
        .table-file__name {
          width: 86%;
          @media screen and (max-width: $sm) {
            width: 70%;
          }
          @media screen and (max-width: $xs) {
            width: 65%;
          }
        }
      }
    }
  }
}
.cos-drag-area {
  .tc-15-table-panel {
    border: 1px dashed #409eff;
  }
}
</style>
